
/**
* Inspire-hub 2 (www.giap.pl)
*
* Copyright © GIAP sp.z.o.o. All rights reserved.
*
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
* Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
*/
/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../../../components/GrayPanel';
import Paper from '../../../../components/Paper';
import FormRow from '../../../../components/FormRow';
import ModalAlert from '../../../../components/ModalAlert';

import { adminEndpoint } from '../../../../config';
import fetch from '../../../../core/fetch';

import s from './AddAvailableService.css';

const btnStyles = { margin: '10px' };

class AddAvailableService extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  state = {
    shortName: 'test',
    title: '',
    description: '',
    requiresLicence: false,
    requiresUserInfo: false,
    requiresEPUAP: false,
    requiresProton: false,
    isEnabled: false,
    demoURL: null,
    iconURL: null,
    showModal: false,
    modalTitle: '',
    modalText: '',
    shouldRedirect: false,
  }

  onChange = (e, callback = null) => this.setState({ [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }, callback);
  onHide = () => this.setState({ showModal: false }, () => {
    if (this.state.shouldRedirect) {
      window.location.href = this.redirectURL;
    }
  });

  redirectURL = `${adminEndpoint}/available_services`;
  postServiceURL = `${process.env.API_URL}/available_services`;

  add = () => fetch(this.postServiceURL,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.state),
    }
  )
    .then(r => {
      if (r.status === 200) {
        return r.json();
      } else {
        throw r.text();
      }
    })
    .then(resp => {
      this.setState({ modalText: 'Pomyślnie dodano nową usługę', modalTitle: 'Status dodania usługi', showModal: true, shouldRedirect: true })
    })
    .catch(err => {
      err.then(a => this.setState({ modalText: a, modalTitle: "Błąd", showModal: true, shouldRedirect: false }));
    });

  renderIcon = () => {
    const url = this.state.iconURL;
    if (!url) return;
    const startsWithCondition = (url.startsWith('http') || url.startsWith('https'));
    const endsWithCondition = (url.endsWith('.jpg') || url.endsWith('.JPG') || url.endsWith('.png') || url.endsWith('.PNG'));
    if (startsWithCondition && endsWithCondition) {
      return <img role="presentation" src={this.state.iconURL} />;
    }
    if (url.startsWith('fa-')) {
      return <i className={`fa ${url} fa-4x`} aria-hidden="true" />;
    }
    return null;
  }

  render() {
    return (
      <Paper title={this.props.title}>
        <div className="row">
          <div className="col-sm-2" />
          <div className="col-sm-8">
            <hr />
            <FormRow label="Krótka nazwa" name="shortName" onChange={e => this.onChange(e)} />
            <FormRow label="Tytuł" name="title" onChange={e => this.onChange(e)} />
            <FormRow label="Opis" name="description" type="textarea" onChange={e => this.onChange(e)} />
            <FormRow label="Czy wymaga licencji ?" name="requiresLicence" type="checkbox" onChange={e => this.onChange(e)} />
            <FormRow label="Czy wymaga danych użytkownika ?" name="requiresUserInfo" type="checkbox" onChange={e => this.onChange(e)} />
            <FormRow label="Czy może być z integrowana z EPUAP'em ?" name="requiresEPUAP" type="checkbox" onChange={e => this.onChange(e)} />
            <FormRow label="Czy może być z integrowana z protonem ?" name="requiresProton" type="checkbox" onChange={e => this.onChange(e)} />
            <FormRow label="Czy usługa jest włączona ?" name="isEnabled" type="checkbox" onChange={e => this.onChange(e)} />
            <FormRow label="URL prezentacji usługi" name="demoURL" onChange={e => this.onChange(e)} />
            <FormRow label="Ikona" name="iconURL" onChange={e => this.onChange(e)} />
            {this.renderIcon()}
            <hr />
            <div className="pull-right">
              <a href={this.redirectURL} style={btnStyles} className="btn btn-danger">Anuluj</a>
              <button type="submit" onClick={() => this.add()} style={btnStyles} className="btn btn-primary">Dodaj</button>
            </div>
          </div>
          <div className="col-sm-2" />
        </div>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalText}
          show={this.state.showModal}
          name="statusModal"
          onHide={() => this.onHide()}
        />
      </Paper>
    );
  }
}

export default withStyles(s)(AddAvailableService);



// WEBPACK FOOTER //
// src/routes/admin/available_services/add_availableservices/AddAvailableService.js